export default __webpack_public_path__ + "static/media/ba5c86782f0830d565b9e7f334191207.jpg";